import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PublicError } from "@/components/PublicShell";

export default function ShortLink() {
  const { code } = useParams();
  const nav = useNavigate();
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    api.get(`/public/s/${code}`).then(({ data }) => {
      const q = new URLSearchParams(Object.fromEntries(["utm_source", "utm_medium", "utm_campaign"].filter((k) => data[k]).map((k) => [k, data[k]])));
      nav(`/c/${data.slug}${q.toString() ? `?${q}` : ""}`, { replace: true });
    }).catch(() => setMissing(true));
  }, [code, nav]);
  if (missing) return <PublicError text="This link isn't available." />;
  return <div className="min-h-screen grid place-items-center bg-[#070709]" data-testid="short-link-redirect"><Loader2 className="w-6 h-6 animate-spin text-pink-400" /></div>;
}
